import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { CellData, ComponentData } from '@ddt-web/data-service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

import { PerformanceUtil } from '../utils/performance.util';

@UntilDestroy()
@Component({
	selector: 'perf-fund-performance',
	templateUrl: './fund-performance.component.html',
	styleUrls: ['./fund-performance.component.scss']
})
export class FundPerformanceComponent implements OnInit {
	@Input() public data: ComponentData;
	@Input() public showAssetClasses: boolean = true;

	@Input() public filterInvalidPortfolioData: boolean = false;
	@Input() public mode?: string;
	@Input() public holdingsAsOfDateData?: string;
	@Input() public shouldAddLineSeparator: boolean = true;
	// Input needed for filtering data based on a search form control input
	@Input() public searchFormControl?: UntypedFormControl;
	@Input() public showPagination?: boolean = false;
	@Input() public defaultPageSize?: number;
	@Input() public defaultSortKey?: string;

	public validPortfolioData: CellData[][];
	public searchInput = new UntypedFormControl();
	public selectedPortfolioIndex: number = 0;
	public filterTerm: string;

	public ngOnInit(): void {
		if (this.searchFormControl?.value) {
			this.filterTerm = this.searchFormControl.value;
		}
		this.searchInput.valueChanges
			.pipe(
				debounceTime(500),
				distinctUntilChanged(),
				untilDestroyed(this)
			)
			.subscribe(term => {
				this.filterTerm = term;
			});

		this.validPortfolioData = PerformanceUtil.getFilteredPortfolioData(this.data.portfolioData, !this.showAssetClasses, this.filterInvalidPortfolioData);
	}

	public selectPortfolioToView(index: string): void {
		this.searchInput.setValue('');
		this.selectedPortfolioIndex = Number.parseInt(index, 10);
	}
}
